import mutations from './mutationAuth.js'
import actions from './actionAuth.js'

export default {
  state: {
    userInfo: {},
    isAdmin: false
  },
  mutations,
  actions
}
